import React from 'react';
import SponsorsCarusel from '../../../components/Carusel/Carusel.jsx'
import Text from './SectionCompletedExamples.jsx';
import getFileData from "../../../APICall/Api.jsx";

import Loading from "../../../components/Loading/Loading.jsx";

class SectionSponsors extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      url: getFileData,
      title: this.props.title
    };
  }

  callAPI = () => {
    fetch(`${this.state.url.getFileData}/Sponsors.json`,
      { method: 'get', headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }) }
    )
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result.sponsors
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error: error
          });
        }
      )
  }

  componentDidMount() {
    this.callAPI()
  }

  componentWillReceiveProps(newProps) {
    this.callAPI()
    this.setState({
      title: newProps.title
    })
  }

  render() {
    if (this.state.error) {
      return <div>Error: {this.state.error.message}</div>;
    } else if (!this.state.isLoaded) {
      return <Loading />;
    } else {
      return (
        <div>
          <Text title={this.state.title} />
          <SponsorsCarusel imgs={this.state.items} />
        </div >
      );
    }
  }
}
export default SectionSponsors;


// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionSponsors.jsx